import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { AboutComponent } from './pages/about/about.component';
import { ContactComponent } from './pages/contact/contact.component';
import { VaccancyComponent } from './pages/vaccancy/vaccancy.component';
import { JuniorconsultantComponent } from './pages/juniorconsultant/juniorconsultant.component';
import { LoginComponent } from './pages/login/login.component';
import { RecaptchaModule, RecaptchaFormsModule, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
// import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { NgxCaptchaModule } from 'ngx-captcha';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import { RegisterComponent } from './pages/register/register.component';
import { MainComponent } from './pages/main/main.component';
import { SeniorconsultComponent } from './pages/seniorconsult/seniorconsult.component';
import { IisconsultComponent } from './pages/iisconsult/iisconsult.component';
import { ConsultsankalpComponent } from './pages/consultsankalp/consultsankalp.component';
import { AssociatesankalpComponent } from './pages/associatesankalp/associatesankalp.component';
import { PmuComponent } from './pages/pmu/pmu.component';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from "@angular/common/http";
import { OtrformComponent } from './pages/otrform/otrform.component';
import { DpDatePickerModule } from "ng2-date-picker";
import { TestRegComponent } from './pages/test-reg/test-reg.component';
import { TestotrComponent } from './pages/testotr/testotr.component';
import { TestloginComponent } from './pages/testlogin/testlogin.component';
import { TestdashboardComponent } from './pages/testdashboard/testdashboard.component';
import { TesteditregComponent } from './pages/testeditreg/testeditreg.component';
import { ContentwriterComponent } from './pages/contentwriter/contentwriter.component';
import { EngagingconultComponent } from './pages/engagingconult/engagingconult.component';
import { EngagingtechComponent } from './pages/engagingtech/engagingtech.component';
import { VocationalComponent } from './pages/vocational/vocational.component';
import { PrgrmmanagerComponent } from './pages/prgrmmanager/prgrmmanager.component';
import { FtcseniorComponent } from './pages/ftcsenior/ftcsenior.component';
import { FtccounsellerComponent } from './pages/ftccounseller/ftccounseller.component';
import { FtclegalComponent } from './pages/ftclegal/ftclegal.component';
import { FtcconsultantComponent } from './pages/ftcconsultant/ftcconsultant.component';
import { FtcsdmruComponent } from './pages/ftcsdmru/ftcsdmru.component';
import { FtcprogrammanagerComponent } from './pages/ftcprogrammanager/ftcprogrammanager.component';
import { FtcregionalmanagerComponent } from './pages/ftcregionalmanager/ftcregionalmanager.component';
import { NewassociateComponent } from './pages/newassociate/newassociate.component';
import { ConsultantiisComponent } from './pages/consultantiis/consultantiis.component';
import { ConsultantpmumgnfComponent } from './pages/consultantpmumgnf/consultantpmumgnf.component';
import { ContwritedgtComponent } from './pages/contwritedgt/contwritedgt.component';
import { AssociatechennaiComponent } from './pages/associatechennai/associatechennai.component';
import { AssociatechennaiceilComponent } from './pages/associatechennaiceil/associatechennaiceil.component';
import { JvccbtComponent } from './pages/jvccbt/jvccbt.component';
import { AcadamicconsultComponent } from './pages/acadamicconsult/acadamicconsult.component';
import { NotificationComponent } from './pages/notification/notification.component';
import { JuniorjcsankalpComponent } from './pages/juniorjcsankalp/juniorjcsankalp.component';
import { LegalexpertComponent } from './pages/legalexpert/legalexpert.component';
import { DynmicvacancyComponent } from './pages/dynmicvacancy/dynmicvacancy.component';
import { Conultant01Component } from './pages/conultant01/conultant01.component';
import { Jcconultant02Component } from './pages/jcconultant02/jcconultant02.component';
import { Srconsultant03Component } from './pages/srconsultant03/srconsultant03.component';
import { Consultant04Component } from './pages/consultant04/consultant04.component';
import { Consultantsdmru05Component } from './pages/consultantsdmru05/consultantsdmru05.component';
import { Asssankalp06Component } from './pages/asssankalp06/asssankalp06.component';
import { Jrcongeneral07Component } from './pages/jrcongeneral07/jrcongeneral07.component';
import { Jrdevloper08Component } from './pages/jrdevloper08/jrdevloper08.component';
import { Fullstkdevloper09Component } from './pages/fullstkdevloper09/fullstkdevloper09.component';
import { JrtestengComponent } from './pages/jrtesteng/jrtesteng.component';
import { Mobileappdevop11Component } from './pages/mobileappdevop11/mobileappdevop11.component';
import { Consultant12Component } from './pages/consultant12/consultant12.component';
import { Srconsultant13Component } from './pages/srconsultant13/srconsultant13.component';
import { DataanalystitComponent } from './pages/dataanalystit/dataanalystit.component';
import { ConsultantgeneralComponent } from './pages/consultantgeneral/consultantgeneral.component';
import { MotiongraphicdesignerComponent } from './pages/motiongraphicdesigner/motiongraphicdesigner.component';
import { SankalpConsultantComponent } from './sankalp-consultant/sankalp-consultant.component';
import { SankalpconsultantComponent } from './sankalpconsultant/sankalpconsultant.component';
import { Seniorconsultant1Component } from './seniorconsultant1/seniorconsultant1.component';
import { Seniorconsultant2Component } from './seniorconsultant2/seniorconsultant2.component';
import { ProjectmanagerComponent } from './projectmanager/projectmanager.component';
import { Dataanalytics1Component } from './pages/dataanalytics1/dataanalytics1.component';
import { SeniorpfsdComponent } from './pages/seniorpfsd/seniorpfsd.component';
import { SenpfsdComponent } from './pages/senpfsd/senpfsd.component';
import { DataarcComponent } from './pages/dataarc/dataarc.component';
import { ProgrammerssComponent } from './pages/programmerss/programmerss.component';
import { ConsulComponent } from './pages/consul/consul.component';
import { FullsdapiComponent } from './pages/fullsdapi/fullsdapi.component';
import { Programmerss1Component } from './pages/programmerss1/programmerss1.component';
import { Senpfsd1Component } from './pages/senpfsd1/senpfsd1.component';
import { ProgrammersssComponent } from './pages/programmersss/programmersss.component';
import { Consultant03Component } from './pages/consultant03/consultant03.component';
import { Consultantquest03Component } from './pages/consultantquest03/consultantquest03.component';
import { Consultantdev03Component } from './pages/consultantdev03/consultantdev03.component';
import { Juniorconsultant03Component } from './pages/juniorconsultant03/juniorconsultant03.component';
import { Seniorconsultant03Component } from './pages/seniorconsultant03/seniorconsultant03.component';
import { Consultant0317Component } from './pages/consultant0317/consultant0317.component';
import { MulticonsComponent } from './pages/multicons/multicons.component';
import { ArdevelopComponent } from './pages/ardevelop/ardevelop.component';
import { AnimatorComponent } from './pages/animator/animator.component';
import { EditorComponent } from './pages/editor/editor.component';
import { SeniorfullComponent } from './seniorfull/seniorfull.component';
import { ProssComponent } from './pages/pross/pross.component';
import { DatalystComponent } from './pages/datalyst/datalyst.component';
import { FevidevComponent } from './pages/fevidev/fevidev.component';
import { SaneComponent } from './pages/sane/sane.component';
import { SystemadmComponent } from './pages/systemadm/systemadm.component';
import { JuniorproComponent } from './pages/juniorpro/juniorpro.component';
import { WebmobilComponent } from './pages/webmobil/webmobil.component';
import { AccountcComponent } from './accountc/accountc.component';
import { AccconsComponent } from './pages/acccons/acccons.component';
import { SrconmultiComponent } from './srconmulti/srconmulti.component';
import { ConquestionComponent } from './conquestion/conquestion.component';
import { MultimcoComponent } from './pages/multimco/multimco.component';
import { ConseniorComponent } from './consenior/consenior.component';
import { CoordmultiComponent } from './coordmulti/coordmulti.component';
import { SconsulComponent } from './sconsul/sconsul.component';
import { LanguageComponent } from './pages/language/language.component';
import { SeniorrndComponent } from './seniorrnd/seniorrnd.component';
import { SenmcComponent } from './senmc/senmc.component';
import { OfficesecComponent } from './officesec/officesec.component';
import { PhotograpComponent } from './photograp/photograp.component';
import { QuestaiComponent } from './pages/questai/questai.component';
import { SenitComponent } from './senit/senit.component';
import { ConfinaccComponent } from './pages/confinacc/confinacc.component';
import { ConsanpmuComponent } from './pages/consanpmu/consanpmu.component';
import { MultismcComponent } from './pages/multismc/multismc.component';
import { MultidmComponent } from './pages/multidm/multidm.component';
import { MultiysComponent } from './pages/multiys/multiys.component';
import { Juniorcon24Component } from './juniorcon24/juniorcon24.component';
import { ContwriteComponent } from './pages/contwrite/contwrite.component';



@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutComponent,
    ContactComponent,
    VaccancyComponent,
    JuniorconsultantComponent,
    LoginComponent,
    RegisterComponent,
    MainComponent,
    SeniorconsultComponent,
    IisconsultComponent,
    ConsultsankalpComponent,
    AssociatesankalpComponent,
    PmuComponent,
    OtrformComponent,
    TestRegComponent,
    TestotrComponent,
    TestloginComponent,
    TestdashboardComponent,
    TesteditregComponent,
    ContentwriterComponent,
    EngagingconultComponent,
    EngagingtechComponent,
    VocationalComponent,
    PrgrmmanagerComponent,
    FtcseniorComponent,
    FtccounsellerComponent,
    FtclegalComponent,
    FtcconsultantComponent,
    FtcsdmruComponent,
    FtcprogrammanagerComponent,
    FtcregionalmanagerComponent,
    NewassociateComponent,
    ConsultantiisComponent,
    ConsultantpmumgnfComponent,
    ContwritedgtComponent,
    AssociatechennaiComponent,
    AssociatechennaiceilComponent,
    JvccbtComponent,
    AcadamicconsultComponent,
    NotificationComponent,
    JuniorjcsankalpComponent,
    LegalexpertComponent,
    DynmicvacancyComponent,
    Conultant01Component,
    Jcconultant02Component,
    Srconsultant03Component,
    Consultant04Component,
    Consultantsdmru05Component,
    Asssankalp06Component,
    Jrcongeneral07Component,
    Jrdevloper08Component,
    Fullstkdevloper09Component,
    JrtestengComponent,
    Mobileappdevop11Component,
    Consultant12Component,
    Srconsultant13Component,
    DataanalystitComponent,
    ConsultantgeneralComponent,
    MotiongraphicdesignerComponent,
    SankalpConsultantComponent,
    SankalpconsultantComponent,
    Seniorconsultant1Component,
    Seniorconsultant2Component,
    ProjectmanagerComponent,
    Dataanalytics1Component,
    SeniorpfsdComponent,
    SenpfsdComponent,
    DataarcComponent,
    ProgrammerssComponent,
    ConsulComponent,
    FullsdapiComponent,
    Programmerss1Component,
    Senpfsd1Component,
    ProgrammersssComponent,
    Consultant03Component,
    Consultantquest03Component,
    Consultantdev03Component,
    Juniorconsultant03Component,
    Seniorconsultant03Component,
    Consultant0317Component,
    MulticonsComponent,
    ArdevelopComponent,
    AnimatorComponent,
    EditorComponent,
    SeniorfullComponent,
    ProssComponent,
    DatalystComponent,
    FevidevComponent,
    SaneComponent,
    SystemadmComponent,
    JuniorproComponent,
    WebmobilComponent,
    AccountcComponent,
    AccconsComponent,
    SrconmultiComponent,
    ConquestionComponent,
    MultimcoComponent,
    ConseniorComponent,
    CoordmultiComponent,
    SconsulComponent,
    LanguageComponent,
    SeniorrndComponent,
    SenmcComponent,
    OfficesecComponent,
    PhotograpComponent,
    QuestaiComponent,
    SenitComponent,
    ConfinaccComponent,
    ConsanpmuComponent,
    MultismcComponent,
    MultidmComponent,
    MultiysComponent,
    Juniorcon24Component,
    ContwriteComponent,


  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    FormsModule,ReactiveFormsModule,
    HttpClientModule,
    DpDatePickerModule
  ],
  providers: [{
    provide: RECAPTCHA_SETTINGS,
    useValue: {
      siteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    } as RecaptchaSettings,
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
